import { useState } from 'react';

export default function Tooltip({ text, children }) {
    const [show, setShow] = useState(false);

    if (!text) return children || null;

    return (
        <span className="relative inline-flex items-center">
            {children || (
                <button
                    type="button"
                    onMouseEnter={() => setShow(true)}
                    onMouseLeave={() => setShow(false)}
                    onClick={(e) => { e.preventDefault(); setShow(!show); }}
                    className="w-4 h-4 rounded-full bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-gray-600 inline-flex items-center justify-center text-[10px] font-bold leading-none transition-colors"
                >
                    ?
                </button>
            )}
            {show && (
                <span className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-1.5 px-2.5 py-1.5 text-xs text-white bg-gray-900 rounded-md shadow-lg whitespace-normal max-w-64 text-center pointer-events-none">
                    {text}
                    <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
                </span>
            )}
        </span>
    );
}
